import { useState } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Checkbox } from "@/components/ui/checkbox";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { Loader2, Search, ExternalLink } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export function CofounderTab({ profile, update }) {
  const [cofounders, setCofounders] = useState([]);
  const [searching, setSearching] = useState(false);

  const search = async () => {
    setSearching(true);
    try {
      const r = await fetch(`${BACKEND_URL}/api/aspiring/potential-cofounders`, { credentials: "include" });
      if (r.ok) setCofounders((await r.json()).cofounders || []);
    } catch {}
    setSearching(false);
  };

  return (
    <div className="space-y-4">
      <h2 className="text-xl font-bold">Your Cofounder</h2>
      <Card className={profile.no_cofounder ? "border-amber-300 bg-amber-50/50" : ""}>
        <CardContent className="p-4">
          <div className="flex items-center gap-3 mb-4 cursor-pointer" onClick={() => update("no_cofounder", !profile.no_cofounder)}>
            <Checkbox checked={profile.no_cofounder || false} />
            <Label className="cursor-pointer font-medium">I don't have a cofounder yet</Label>
          </div>
          {profile.no_cofounder ? (
            <div className="space-y-4">
              <Button onClick={search} disabled={searching} className="bg-amber-500 hover:bg-amber-600">
                {searching ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : <Search className="w-4 h-4 mr-2" />}
                Find a cofounder
              </Button>
              {cofounders.length > 0 && (
                <Table>
                  <TableHeader><TableRow><TableHead>Name</TableHead><TableHead>Role</TableHead><TableHead>Skills</TableHead><TableHead></TableHead></TableRow></TableHeader>
                  <TableBody>
                    {cofounders.map((c, i) => (
                      <TableRow key={i}>
                        <TableCell>{c.name || "Anonymous"}</TableCell>
                        <TableCell><Badge variant="secondary">{c.preferred_role || "-"}</Badge></TableCell>
                        <TableCell>{(c.skills || []).slice(0,2).join(", ")}</TableCell>
                        <TableCell>{c.linkedin_url && <a href={c.linkedin_url} target="_blank" className="text-blue-600"><ExternalLink className="w-4 h-4" /></a>}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              )}
            </div>
          ) : (
            <div className="space-y-4">
              <div className="grid grid-cols-2 gap-4">
                <div><Label>Name</Label><Input value={profile.cofounder_name || ""} onChange={e => update("cofounder_name", e.target.value)} /></div>
                <div><Label>LinkedIn</Label><Input value={profile.cofounder_linkedin || ""} onChange={e => update("cofounder_linkedin", e.target.value)} /></div>
              </div>
              <div><Label>Role</Label><Input value={profile.cofounder_role || ""} onChange={e => update("cofounder_role", e.target.value)} placeholder="e.g., CEO, CSO" /></div>
              <div><Label>Skills</Label><Textarea value={profile.cofounder_skills || ""} onChange={e => update("cofounder_skills", e.target.value)} rows={2} /></div>
              <div><Label>How you met</Label><Textarea value={profile.how_you_met || ""} onChange={e => update("how_you_met", e.target.value)} rows={2} /></div>
              <div><Label>Why them?</Label><Textarea value={profile.why_this_person || ""} onChange={e => update("why_this_person", e.target.value)} rows={2} /></div>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
